import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SaleModule } from '../sale/sale.module'
import { CartItemModule } from './cart-item/cart-item.module'
import { CartRoutingModule } from './cart-routing.module'
import { CartShowComponent } from './show/show.component'
import { RoleModule } from '../role/role.module'

@NgModule({
  imports: [
    CommonModule,
    CartItemModule,
    CartRoutingModule,
    SharedModule,
    SaleModule,
    RoleModule
  ],
  providers: [],
  declarations: [CartShowComponent],
  exports: []
})
export class CartModule {}
